<template>
    <v-card class="pa-0 ma-4 mt-0">
        <v-card-title class="justify-center"><h3>Agent Preferences</h3></v-card-title>

        <v-card-actions class="justify-center">
            <!-- <v-btn class="primary ma-0" small @click="autoDeduplicate">Auto deduplicate</v-btn> -->
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        props: {
        },
        components: {
        },
        data() {
            return {
            }
        },
        mounted() {
        },       
        methods: {
        },
    }
</script>

<style scoped>

</style>